const FOCUSABLE_SELECTOR = [
  'a[href]',
  'button:not([disabled])',
  'input:not([disabled])',
  'select:not([disabled])',
  'textarea:not([disabled])',
  '[tabindex]:not([tabindex="-1"])',
].join(',')

export function trapDialogFocus(
  event: globalThis.KeyboardEvent,
  dialog: globalThis.HTMLElement | null
): void {
  if (!dialog) return

  const focusableElements = Array.from(
    dialog.querySelectorAll<globalThis.HTMLElement>(FOCUSABLE_SELECTOR)
  ).filter(element => !element.hasAttribute('hidden'))

  if (focusableElements.length === 0) {
    event.preventDefault()
    dialog.focus()
    return
  }

  const firstElement = focusableElements[0]
  const lastElement = focusableElements[focusableElements.length - 1]
  const activeElement = document.activeElement

  if (event.shiftKey && (activeElement === firstElement || activeElement === dialog)) {
    event.preventDefault()
    lastElement?.focus()
  } else if (!event.shiftKey && (activeElement === lastElement || activeElement === dialog)) {
    event.preventDefault()
    firstElement?.focus()
  }
}
